import ReactDOM from "react-dom/client";
import "./index.css";
import { configureDayjs } from "./configureDayjs.ts";
import { MainComponent } from "./MainComponent.tsx";
import { configureSentry } from "./Sentry/configureSentry.ts";
configureSentry();
configureDayjs();

ReactDOM.createRoot(document.getElementById("root")!).render(<MainComponent />);
